import HistoriqueConfigs from '@/views/parametres/configs/historique-configs'
import $ from 'jquery'

export default {
    name: 'param-devise',
    components: {
        HistoriqueConfigs
    },
    props: {
        user_info: Object
    },
    data() {
        return {
            currency: {
                has_two_currencies: false,
                label_principal_currency: '',       // Designation
                label_secondary_currency: '',
                principal_currency: '',             // Sigle
                secondary_currency: '',
                currency_lang: '',
                rate: ''
            },
            is_loading: false,
            save_loading: false,
            can_edit: false,
            current_data: {
                has_two_currencies: false,
                label_principal_currency: '',
                label_secondary_currency: '',
                principal_currency: '',
                secondary_currency: '',
                currency_lang: '',
                rate: ''
            },
            toggler: 0
        }
    },

    computed: {
        info_currency() {
            return this.$store.getters["info_currency"];
        },
    },

    watch: {
        // Réagit à un changement de devise déclenché ailleurs (ex. choix du pays dans Infos clinique).
        info_currency() {
            this.initFields()
        }
    },

    mounted() {
        this.getDiversInfo()
    },

    methods: {
        async getDiversInfo() {
            this.is_loading = true

            // Une devise déduite du pays et pas encore enregistrée : ne pas l'écraser par l'ancienne valeur en base.
            if (this.$store.getters['currency_defaults_pending']) {
                this.initFields()
                return
            }

            this.$store.dispatch('getConfigInfoClinique', 'currency').then(() => {
                this.initFields()
            })
        },

        initFields() {
            const fld_keys = Object.keys(this.currency);
            fld_keys.forEach((key) => {
                this.currency[key] = this.info_currency[key]
                this.current_data[key] = this.info_currency[key]
                this.is_loading = false
            });
        },

        async saveCurrency() {
            const isValid = await this.$refs.currency_form.validate();

            if (!isValid) {
                return;
            }

            if (this.currency.has_two_currencies == false) {
                this.currency.label_secondary_currency = ''
                this.currency.secondary_currency = ''
            }

            let form_data = new FormData();
            for (let key in this.currency) {
                form_data.append(key, this.currency[key])
            }
            form_data.append('data_type', 'currency')

            this.save_loading = true
            this.$store.dispatch('saveConfigInfoClinique', form_data).then((response) => {
                if (response > 0) {
                    this.successToast("Devise mise à jour avec succès")

                    let historique_data = {
                        current_data: this.current_data,
                        new_data: this.currency,
                        data_type: 'currency',
                        user_info: {
                            id: this.user_info.id,
                            user: this.user_info.name,
                            titre: this.user_info.titre
                        }
                    }

                    this.$store.dispatch('storeConfigHistorique', historique_data)
                }

                this.save_loading = false
            })
        },

        viewCurrencyHistorique() {
            this.toggler = (this.toggler == 1)?0:1

            $('.view-config-histo').modal('show')
        }
    }
}